<template>
  <v-select :items="vehicles" item-value="id" v-model="vehicleId" @change="handleInput" label="Fahrzeug">
    <template slot="item" slot-scope="data">
      {{ data.item.title }}
    </template>
    <template slot="selection" slot-scope="data">
      {{ data.item.title }}
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'VehicleSelect',
  prop: ['value'],
  computed: {
    vehicles () {
      return this.$store.state.vehicle.all
    }
  },
  data () {
    return {
      vehicleId: this.value
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', this.vehicleId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/_vehicleSelect.vue